<script lang="ts">
  import { FormGroup } from "carbon-components-svelte";
  import SpacingGroup from "../common/SpacingGroup.svelte";
  import type { ISpacing } from "src/ts/Interfaces";

  export let spacing: ISpacing;
  export let hidden: boolean;
</script>

{#if !hidden}
  <div class="pane">
    <FormGroup legendText="Configure spacing around the border" class="step">
      <SpacingGroup bind:spacing />
    </FormGroup>
  </div>
{/if}
